import { createContext, useContext } from 'react'

export const I18NContext = createContext<{ namespacesLoaded: boolean }>({ namespacesLoaded: false })

export const useI18NContext = () => useContext(I18NContext)
